<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showLabelForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
           <a-form-model-item label="绑定标签" prop="label">
                <a-select placeholder="请选择" :default-value="model.label" show-search option-filter-prop="children"
                          v-model="model.label">
                    <a-select-option :value="label.id" v-for="label in labels" :key="label.id">
                        {{ label.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Label';
</style>

<script>
import Label from './Label'
export default Label
</script>
